import { createSelector } from 'reselect';

export default createSelector(
    state => state.seat_selection.orm,
    (orm) => {
        const { history, ...models } = orm;
        return models;
    },
);
